























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ApiService from "@/service/ApiService";
import Card from "@/components/Card/Card.vue";
import Input from "@/components/Form/elements/Input.vue";


@Component({
  components: {Input, Card}
})
export default class Exports extends Vue {
  public name: string = "Exports";

  private paramsList: Array<any> = [];
  private sheetTitle: string = '';

  @Prop({required: true})
  public params!: any;

  @Prop({required: false, default: true})
  public active!: boolean;

  private exportNow(): void {

    this.$emit('on-export', this.paramsList);

  }

  private saveParams(): void {

    let params = {...this.params};

    if (this.sheetTitle !== '') {

      // TODO add unique check!
      params.sheet_title = this.sheetTitle;

    }

    this.paramsList.push(params);

    this.sheetTitle = '';

  }


}
